import { render, staticRenderFns } from "./ObjetivoVendas.vue?vue&type=template&id=887321fe&scoped=true"
import script from "./ObjetivoVendas.vue?vue&type=script&lang=js"
export * from "./ObjetivoVendas.vue?vue&type=script&lang=js"
import style0 from "./ObjetivoVendas.vue?vue&type=style&index=0&id=887321fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887321fe",
  null
  
)

export default component.exports